import React, { Component, createRef } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Modal from '@app/components/ui/modals/Modal'
import Notice from '@app/components/ui/notifications/Notice'
import ActionButton from '@app/components/ui/buttons/ActionButton'
import { h } from '@app/helpers/translationHelper'
import * as studentActions from '@app/actions/students'
import _ from 'lodash'

class FinishNotice extends Component {
  constructor(props) {
    super(props)
    this.handleFinish = this.handleFinish.bind(this)
    this.modal = createRef(null)
  }

  handleFinish(_) {
    const { boundStudentActions } = this.props
    boundStudentActions.finishOlypiad({ tour: 'main' })
  }

  render() {
    const { statistics: { objects } } = this.props
    if ( !_.every(objects, 'answer') ) { return null }

    const { student, finish: { finishing } } = this.props
    return (
      <div className="student-tasks-page__notice">
        <Notice theme="danger">
          <div className="student-tasks-page__notice-inner">
            <p className="paragraph black"
               dangerouslySetInnerHTML={ h('students.at_main_tour.notice_html') }
            />

            <a href="javascript:void(0)"
               className="btn btn--red btn--md f--upper"
               onClick={ () => this.modal.current.open() }>

              { I18n.t('students.at_main_tour.notice_button') }
            </a>
          </div>
        </Notice>
        <Modal ref={this.modal} className="modal--md">
          <p className="plate-content text-left f--l"
             dangerouslySetInnerHTML={
              h(`students.at_main_tour.notice.confirm${student.isFemale ? '_f' : ''}_html`)
          } />

          <div className="mt-1 w-flex-layout w-flex-layout--columns">
            <a href="javascript:void(0)"
               onClick={ () => this.modal.current.close() }
               className="btn btn--light-blue f--upper">

              { I18n.t('students.at_main_tour.notice.cancel') }
            </a>

            <ActionButton
              className="btn btn--blue f--upper"
              onClick={this.handleFinish}
              disabled={finishing}
              loading={finishing}>
              { I18n.t('students.at_main_tour.notice.finish') }
            </ActionButton>
          </div>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { students: { finish } } = state;
  return { finish }
}

const mapDispatchToProps = (dispatch) => {
  const boundStudentActions = bindActionCreators(studentActions, dispatch)
  return { boundStudentActions }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FinishNotice)
